import { useRouter } from 'next/router';

import BooksList from '@/components/Books/BooksList';
import type { Book } from '@/components/Books/types';

const BOOKS_ENDPOINT = process.env.NEXT_PUBLIC_BOOKS_CDN_URL ?? '';

const BooksPage = () => {
  const router = useRouter();

  const handleBookClick = (book: Book) => {
    void router.push(`/books/${encodeURIComponent(book.id)}`);
  };

  const handleBookEnter = (book: Book) => {
    void router.prefetch(`/books/${encodeURIComponent(book.id)}`);
    void import('react-pdf');
  };

  return (
    <BooksList
      booksEndpoint={BOOKS_ENDPOINT}
      heading="Books"
      onBookClick={handleBookClick}
      onBookEnter={handleBookEnter}
    />
  );
};

export default BooksPage;

